import { render, staticRenderFns } from "./Pms.vue?vue&type=template&id=827a12de"
import script from "./Pms.vue?vue&type=script&lang=js"
export * from "./Pms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports